import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import TechNotesView from "@/views/TechNotesView.vue";
import TechNoteDetailView from "@/views/TechNoteDetailView.vue";
import LightVideosView from "@/views/LightVideosView.vue";
import LightVideoDetailView from "@/views/LightVideoDetailView.vue";
import SoundBlankView from "@/views/SoundBlankView.vue";
import CommonSoftwareView from "@/views/CommonSoftwareView.vue";
import AdminView from "@/views/AdminView.vue";
import TechNoteEditorView from "@/views/TechNoteEditorView.vue";
import XFPaintView from "@/views/XFPaintView.vue";
import GupiaoAccessView from "@/views/GupiaoAccessView.vue";
import { useAuthStore } from "@/store/authStore";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "圣域空间 | 首页",
    },
  },
  {
    path: "/tech-notes",
    name: "tech-notes",
    component: TechNotesView,
    meta: {
      title: "圣域空间 | 技术手记",
      bodyClass: "page-tech-notes",
      mainClass: "notes-page-main",
    },
  },
  {
    path: "/tech-notes/:slug",
    name: "tech-note-detail",
    component: TechNoteDetailView,
    meta: {
      title: "圣域空间 | 技术手记详情",
      bodyClass: "page-tech-article",
      mainClass: "article-page-main",
    },
  },
  {
    path: "/light-videos",
    name: "light-videos",
    component: LightVideosView,
    meta: {
      title: "圣域空间 | 光影音域",
      bodyClass: "page-light-videos",
      mainClass: "notes-page-main",
    },
  },
  {
    path: "/light-videos/:slug",
    name: "light-video-detail",
    component: LightVideoDetailView,
    meta: {
      title: "圣域空间 | 光影音域详情",
      bodyClass: "page-light-video",
      mainClass: "article-page-main",
    },
  },
  {
    path: "/sound-blank",
    name: "sound-blank",
    component: SoundBlankView,
    meta: {
      title: "圣域空间 | 声音留白",
      bodyClass: "page-sound-blank",
      mainClass: "notes-page-main sound-page-main",
      requiresLogin: true,
    },
  },
  {
    path: "/common-software",
    name: "common-software",
    component: CommonSoftwareView,
    meta: {
      title: "圣域空间 | 常用软件",
      bodyClass: "page-common-software",
      mainClass: "notes-page-main software-page-main",
    },
  },
  {
    path: "/xfpaint",
    name: "xfpaint",
    component: XFPaintView,
    meta: {
      title: "小范共享去水印工具 | 官方页面",
      bodyClass: "page-xfpaint",
      mainClass: "xfpaint-page-main",
      standaloneLayout: true,
    },
  },
  {
    path: "/gupiao",
    name: "gupiao",
    component: GupiaoAccessView,
    meta: {
      title: "股票分析 | 跳转中",
      requiresLogin: true,
    },
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminView,
    meta: {
      title: "圣域空间 | 后台管理",
      mainClass: "admin-page-main",
      requiresAdmin: true,
    },
  },
  {
    path: "/admin/tech-notes/:noteId/editor",
    name: "admin-tech-note-editor",
    component: TechNoteEditorView,
    meta: {
      title: "圣域空间 | 技术手记编辑器",
      bodyClass: "page-admin-editor",
      mainClass: "editor-workbench-main",
      requiresAdmin: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return {
      top: 0,
    };
  },
});

router.beforeEach(async (to) => {
  const { canAccessAdmin, ensureSessionLoaded, isLoggedIn } = useAuthStore();

  if (to.meta.requiresLogin || to.meta.requiresAdmin) {
    await ensureSessionLoaded();
  }

  if (to.meta.requiresLogin && !isLoggedIn.value) {
    if (typeof window !== "undefined") {
      window.alert("请登录");
    }
    return {
      path: "/",
    };
  }

  if (to.meta.requiresAdmin) {
    if (!canAccessAdmin.value) {
      return {
        path: "/",
      };
    }
  }

  return true;
});

export default router;
